import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import LastRepaymentScheduleModalUI from './LastRepaymentScheduleModalUI.js'

class LastRepaymentScheduleModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      status: null,
      scheduledDate: '',
      scheduledDateError: null,
    }
  }

  render() {
    return (
      <LastRepaymentScheduleModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        status={this.state.status}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        scheduledDate={this.state.scheduledDate}
        onScheduledDateChange={(scheduledDate) => { this.setState({ scheduledDate: scheduledDate }) }}
        scheduledDateError={this.state.scheduledDateError}
        setScheduledDateError={(error) => { this.setState({ scheduledDateError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/repayments/last`,
      this.onSubmitCallback, {
      scheduledDateISO: this.state.scheduledDate
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null,
          scheduledDate: '',
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default LastRepaymentScheduleModalSF
